import React from "react";
import "./App.css";
import Header from "./components/Header";
import Academy from "./pages/Academy";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NoPage from "./pages/NoPage";
import FormSheet from "./pages/FormSheet";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import TermsAndCondition from "./pages/TermsAndCondition";
import Faq from "./pages/Faq";
import AlertModal from "./components/AlertModal";
import FinancialAid from "./pages/FinancialAid";
import ScrollToTop from "./components/ScrollToTop";
import FinaicialAidPayment from "./pages/SecondaryPayment";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <AlertModal />
      <ScrollToTop>
        <Routes>
          <Route path="/" index element={<Academy />} />
          <Route path="/bootcamp" element={<Academy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/enroll/:slug" element={<FormSheet />} />
          <Route path="/termsandconditions" element={<TermsAndCondition />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/financial-aid" element={<FinancialAid />} />
          <Route
            path="/installmental-payment"
            element={<FinaicialAidPayment />}
          />
          <Route path="*" element={<NoPage />} />
        </Routes>


      </ScrollToTop>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
